const detectFormatLinks = (text: string) => {
  if (!text) {
    return ''
  }
  text = text.replace('<script>', '[script]')
  
  // Erst Hashtags verarbeiten (bevor URLs zu HTML werden)
  const hashtagRegex = /(^|\s|>)(#[^\s<]+)/
  const hashtagRegexGlobal = /(^|\s|>)(#[^\s<]+)/g
  text = text.replace(hashtagRegexGlobal, (match, firstChar, hashtag) => {
    const hashtagText = hashtag.replace('#', '').trim()
    return `${firstChar}<a href="https://www.facebook.com/hashtag/${hashtagText}" target="_blank">${hashtag}</a>`
  })
  
  // Dann URLs verarbeiten (Hashtags in URLs werden nicht mehr erkannt)
  // Negative lookbehind um URLs zu vermeiden, die bereits in href-Attributen stehen
  const urlRegex = /(?<!href="|href=')https?:\/\/[^\s<>)\]}"]+(?!")/g
  text = text.replace(urlRegex, (url) => `<a href="${url}" target="_blank">${url}</a>`)
  
  // Email processing bleibt unverändert
  const urlRegexMail = /([^\s>\n]+@[^!?\s<]+)/g
  text = text.replace(urlRegexMail, (mail) => `<a href="mailto:${mail}">${mail}</a>`)

  const mentionRegex = /(^|\s)@\[([^:]+):([^:]+):([^\]]+)]/
  const mentionRegexGlobal = /(^|\s)@\[([^:]+):([^:]+):([^\]]+)]/g

  text = text.replace(mentionRegexGlobal, (mention) => {
    const match = mention.match(mentionRegex)
    // if there is a whitespace character at the start of the mention, preserve it
    const firstChar = match ? match[1] : ''
    // id of the mentioned facebook page
    const pageId = match ? match[2] : ''
    // weird number with unknown purpose
    // const unknownId = match ? match[3] : ''
    // name of the facebook page, to be displayed as the link label
    const name = match ? match[4] : ''
    const result = `${firstChar
    }<a href="https://www.facebook.com/${pageId
    }" target="_blank">${
      name}</a>`
    return result
  })

  return text
}
export default detectFormatLinks
